export const productGalleryContent = {
  container: '#productGallery',
  cloudName: '', // populated in components/image360Carousel
  mediaAssets: [], // populated in components/image360Carousel
  carouselStyle: 'thumbnails',
  carouselLocation: 'left',
  navigation: 'none',
  aspectRatio: '16:9',
  thumbnailProps: {
    width: 112,
    height: 96,
    mediaSymbolPosition: 'center',
    mediaSymbolBgShape: 'radius',
    selectedStyle: 'border',
    selectedBorderColor: '#d0021b',
    selectedBorderPosition: 'all',
    selectedBorderWidth: 1,
    mediaSymbolBgOpacity: 0.8,
  },
  zoom: true,
  zoomProps: {
    level: 2.5,
  },
  themeProps: {
    primary: '#ffffff',
    onPrimary: '#000000',
    active: '#d0021b',
  },
  transition: 'none',
  viewportBreakpoints: [],
};



// WEBPACK FOOTER //
// ./src/main/ui/react/cloudinary/productGalleryContent.js